'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _Through = require('./Through');

var _Through2 = _interopRequireDefault(_Through);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var throughDirect = function throughDirect(areaName) {
  return function (Component) {
    return function (props) {
      return _react2.default.createElement(
        _Through2.default,
        { area: areaName, direct: true, 'default': {} },
        function (data) {
          return _react2.default.createElement(Component, _extends({}, props, data));
        }
      );
    };
  };
};

exports.default = throughDirect;